import { CalendarSettings, CalendarSettingsForm } from '../../CalendarSettings'

import {
  CALENDAR_SETTINGS_FORMS_FIXTURES,
  CalendarSettingsFormsFixture,
} from './CalendarSettingsForms.constants'
import {
  CALENDAR_SETTINGS_FORMS_EMPTY,
  CALENDAR_SETTINGS_FORMS_MANY_TASK_TYPES,
  saveCalendarSettingsFormsDemo,
} from './CalendarSettingsForms.mock'

export function getCalendarSettingsFormsFixtures() {
  return CALENDAR_SETTINGS_FORMS_FIXTURES
}

export function getCalendarSettingsFormsFixtureContent(fixture) {
  switch (fixture) {
    case CalendarSettingsFormsFixture.manyTaskTypes:
      return (
        <CalendarSettingsForm
          key={fixture}
          settings={CALENDAR_SETTINGS_FORMS_MANY_TASK_TYPES}
          onSave={saveCalendarSettingsFormsDemo}
        />
      )
    case CalendarSettingsFormsFixture.empty:
      return (
        <CalendarSettingsForm
          key={fixture}
          settings={CALENDAR_SETTINGS_FORMS_EMPTY}
          onSave={saveCalendarSettingsFormsDemo}
        />
      )
    default:
      return <CalendarSettings />
  }
}
